export default {
  GET_VIEWED_ASSETS_TASKS_COMPLETION: "[viewedAssets] GET List Of Viewed Assets",
  SET_VIEWED_ASSETS_TASKS_TO_STATE: "[viewedAssets] SET List Of tasks to state",
  SET_VIEWED_ASSETS_TASK_TO_COMPLETE: "[viewedAssets] SET List Of tasks to state",

  MARK_TASK_AS_COMPLETE: "[viewedAssets] Mark task as complete",

  // INSERTION_PT (for script, do not remove)
};
